import {
  AfterContentInit,
  Component,
  ElementRef,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
  inject,
  output,
  WritableSignal,
  signal,
} from '@angular/core';
import {
  Btn,
  FormButton,
  FormGroup,
  FormRow,
  FormSubmitEmitterType,
  StorageService,
  Translation,
} from '@ckmk/angular';
import { PostFilterFormType } from '@app/src/app/modules/post/classes/default/form/post.filter.form.type';

@Component({
  selector: 'post-filter',
  standalone: true,
  imports: [FormGroup, FormButton, FormRow, Translation, Btn],
  templateUrl: './post-filter.html',
  styleUrl: './post-filter.scss',
  encapsulation: ViewEncapsulation.None,
})
export class PostFilter
  implements OnInit, OnChanges, OnDestroy, AfterContentInit
{
  protected readonly self = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly storage = inject(StorageService);

  protected readonly formType = inject(PostFilterFormType);

  public readonly filterEmitter = output<any>({ alias: 'onFilter' });

  protected readonly localData: WritableSignal<any> = signal<any>({});

  protected readonly opened: WritableSignal<boolean> = signal<boolean>(false);

  public constructor() {
    if (!this.storage.has('blog')) {
      this.storage.set('blog', {});
    }
  }

  public ngOnInit() {
    this.initLocalData();
  }

  public ngOnChanges(changes: SimpleChanges) {}

  public ngOnDestroy() {}

  public ngAfterContentInit() {}

  protected onClick(event: MouseEvent): void {
    this.toggleOpen(!this.opened);
  }

  protected toggleOpen(value: boolean): void {
    if (value !== this.opened()) {
      const form = this.self.nativeElement.children[1] as HTMLElement;

      if (!value) {
        this.self.nativeElement.style.setProperty(
          '--filter-container-height',
          '43px',
        );
      } else {
        const formHeight = form.getBoundingClientRect().height + 20 + 43;

        this.self.nativeElement.style.setProperty(
          '--filter-container-height',
          `${formHeight}px`,
        );
      }

      this.opened.set(value);
    }
  }

  protected initLocalData(): void {
    if (this.storage.has('blog.categories')) {
      this.localData.update((obj) => ({
        ...obj,
        categories: this.storage.get('blog.categories'),
      }));
    }
  }

  protected onSubmit(event: FormSubmitEmitterType): void {
    this.filterEmitter.emit(event.data[event.name]);
  }
}
